export enum ERole {
  ADMIN = "admin",
}
